import {
  Component, 
  HostBinding, 
  Inject, 
  Input, 
  OnDestroy, 
  OnInit, 
  Output, 
  EventEmitter, ElementRef, Renderer2
} from '@angular/core';
import { PmdAccordion } from './accordion.component';

/**
 * <pmd-accordion-item>
 *
 * This component can be used as a single element to show expandable content, or as one of
 * multiple children of an element with the PmdAccordion directive attached.
 */
@Component({
  selector: 'pmd-accordion-item',
  exportAs: 'pmdAccordionItem',
  templateUrl: './pmd-accordion-item.html',
  host: {
    class: 'accordion-item',
    style: 'display: block',
  }
})

export class PmdAccordionItem implements OnInit, OnDestroy {
  
  /** Clickable text in accordion's group header, check `pmd-accordion-item-header` below for using html in header */
  @Input() heading: string;

  /** Provides an ability to use Bootstrap's contextual panel classes */
  @Input() panelClass: string;

  /** if <code>true</code> — disables accordion group */
  @Input() disabled: boolean;
  
  /** Emits when the opened state changes */
  @Output() onChange: EventEmitter<boolean> = new EventEmitter();
  
  @HostBinding('class.active')
  
  @Input()
  get isOpen(): boolean {
    return this._isOpen;
  }

  set isOpen(value: boolean) {
    if (value !== this.isOpen) {
      if (value) {
        this.accordion.closeOtherPanels(this);
      }
      this._isOpen = value;
      Promise.resolve(null).then(() => {
        this.onChange.emit(value);
      });
    }
  }

  protected isOpenActive = false;
  protected _isOpen = false;
  protected accordion: PmdAccordion;

  constructor(@Inject(PmdAccordion) accordion: PmdAccordion, public elementRef: ElementRef, private renderer: Renderer2) {
    this.accordion = accordion;
  }

  ngOnInit(): any {
    this.panelClass = this.panelClass || 'panel-default';
    this.accordion.addGroup(this);
  }

  ngOnDestroy(): any {
    this.accordion.removeGroup(this);
  }

  toggleOpen(event: Event): any {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }
  
}
